import Card from "react-bootstrap/Card";
import {
  BsFillPlayFill,
  BsHourglassSplit,
  // BsInstagram,
  BsLink45Deg,
} from "react-icons/bs";
import { useLocation } from "react-router-dom";
import { Post } from "../../FeedPost";
import { updateRefClick } from "../../../../Utils/SupabaseServices/ContentDatabase";
import track, {
  handleRedirect,
  handleShop,
  handleTagged,
  TRACKING_TYPES,
} from "../../../../Utils/SupabaseServices/Track";
import Caption from "../Caption";
import React, { useEffect, useRef, useState } from "react";
import HoverVideoPlayer from "react-hover-video-player";
import Comments from "../Comments";
import PostCarousel from "../PostCarousel";
import { RiShoppingBagLine } from "react-icons/ri";
import { isMobile } from "react-device-detect";
import { FiAtSign } from "react-icons/fi";
import { useLoadUser } from "../../../../Utils/customHooks/useLoadUser";
import { Button } from "antd";
import "../CommentsPost/CommentsPost.css";
import "../PostCarousel.css";
import { FaLinkedin } from "react-icons/fa";
import PostInfo from "../../PostInfo/PostInfo";
import { formatPostDate } from "../../../../Utils/StayUpToDate/RenderComponent";

export default function LinkedInPost({
  post,
  showCaption,
  showComments,
  isGlobalView,
  username,
  showAsAd,
  shoppableContent,
  user_id,
  platform,
  name
}: {
  post: Post;
  showCaption: any;
  showComments: any;
  isGlobalView: any;
  username: string;
  showAsAd: any;
  shoppableContent: any;
  user_id: any;
  platform: any;
  name: any
}) {
  const location = useLocation();
  const [showClickablePlayBtn, setShowClickablePlayBtn] = useState(false);
  useEffect(() => {
    if (
      navigator.userAgent.search("Safari") >= 0 &&
      navigator.userAgent.search("Chrome") < 0
    ) {
      setShowClickablePlayBtn(true);
    }
  }, []);

  const placeholderImage = "/assets/dummy_video.png";

  const OverlayStatus = ({
    hover,
    showClickablePlayBtn,
  }: {
    hover: boolean;
    showClickablePlayBtn: boolean;
  }) => {
    return (
      <>{!hover && <BsFillPlayFill className="creator-feed-card-play-btn" />}</>
    );
  };

  const VideoTag = (props: any) => {
    const videoRef: any = useRef();
    const [hover, setHover] = useState(false);
    const [customPause, setCustomPause] = useState(false);
    useEffect(() => {
      videoRef.current.playsInline = true;
    }, []);

    const {
      media_url,
      showAsAd,
      post_date,
      permalink,
      post_id,
      username,
      thumbnail,
      shop_link,
      tagged_link,
      external_link,
      platform,
      name
    } = props;
    return (
      <>
        {!Boolean(media_url) ? (
          <div className="creator-feed-card-video not-available">
            <BsHourglassSplit className="hourglassSplit" />
            <p>
              Work in progress: This content will be available in a few minutes.
            </p>
          </div>
        ) : (
          <div>
            <HoverVideoPlayer
              videoRef={videoRef}
              videoSrc={media_url}
              style={{display:"block"}}
              className="creator-feed-card-video hover-play"
              muted
              preload={"auto"}
              contextMenu="return false;"
              hoverOverlay={<div className="video-hover"></div>}
              pausedOverlay={
                <div className="pause-overlay">
                  <img
                    src={thumbnail ? thumbnail : "/assets/dummy_video.png"}
                    alt=""
                    className="creator-feed-card-video"
                    loading="eager"
                  />

                  <OverlayStatus
                    hover={hover}
                    showClickablePlayBtn={showClickablePlayBtn}
                  />
                </div>
              }
              loadingOverlay={
                <img
                  src={thumbnail ? thumbnail : "/assets/dummy_video.png"}
                  alt=""
                  className="creator-feed-card-video"
                  loading="eager"
                />
              }
              unloadVideoOnPaused
              onHoverStart={() => {
                setHover(true);
              }}
              onHoverEnd={() => {
                setHover(false);
                setCustomPause(false);
              }}
              disableDefaultEventHandling={customPause}
            />

            <RefTag
              media_url={media_url}
              showAsAd={showAsAd}
              post_date={post_date}
              permalink={permalink}
              shop_link={shop_link}
              post_id={post_id}
              username={username}
              tagged_link={tagged_link}
              isVideo={true}
              external_link={external_link}
              platform={platform}
              name={name}
            />
          </div>
        )}
      </>
    );
  };

  const ImagePostTag = React.memo((props: any) => {
    const {
      media_url,
      showAsAd,
      post_date,
      permalink,
      post_id,
      username,
      shop_link,
      tagged_link,
      external_link,
      platform,
      name
    } = props;
    const style: any = {
      width: "100%",
      // height: "300px",
      overflow: "hidden",
      borderRadius: "5px",
      position: "relative",
    };
    return (
      <>
        {media_url === "" ? (
          <div className="creator-feed-card-video not-available">
            <BsHourglassSplit className="hourglassSplit" />
            <p>
              Work in progress: This content will be available in a few minutes.
            </p>
          </div>
        ) : (
          <div className="creator-feed-image-wrapper">
            <Card.Img
              variant="top"
              src={media_url ? media_url : placeholderImage}
              className="creator-feed-card-video-image"
              loading="eager"
              style={{
                backgroundColor: "#f1f1f1",
                ...(media_url.includes("highlight") ||
                  media_url.includes("stories")
                  ? style
                  : {}),
              }}
            />
            <RefTag
              media_url={media_url}
              showAsAd={showAsAd}
              post_date={post_date}
              permalink={permalink}
              shop_link={shop_link}
              post_id={post_id}
              username={username}
              tagged_link={tagged_link}
              external_link={external_link}
              platform={platform}
              name={name}
            />
          </div>
        )}
      </>
    );
  });
  const RefTag = ({
    media_url,
    showAsAd,
    post_date,
    permalink,
    shop_link,
    post_id,
    username,
    tagged_link,
    isVideo,
    external_link,
    platform,
    name,
  }: any) => {
    return (

      <PostInfo
        username={username}
        user_id={user_id}
        showAsAd={showAsAd}
        post_date={post_date}
        permalink={permalink}
        shop_link={shop_link}
        tagged_link={tagged_link}
        external_link={external_link}
        post_id={post_id}
        handleRedirect={handleRedirect}
        handleShop={handleShop}
        handleTagged={handleTagged}
        platform={platform}
        media_url={media_url}
        shoppableContent={shoppableContent}
        name={name}
        isVideo={isVideo}
      />
    );
  };

  return (
    <div className="feed-post">
      {post.media_url ? (
        post.media_url.split(",").length > 1 &&
          post.media_url.split(",").every((url) => url.trim() !== "") ? (
          <PostCarousel
            post={post}
            username={username}
            user_id={user_id}
            isGlobalView={isGlobalView}
            showAsAd={showAsAd}
            shop_link={post.shop_link}
            shoppableContent={shoppableContent}
            external_link={post.external_link}
            platform={platform}
            name={name}
          />
        ) : (
          <>
            {post.media_url.includes("video") ? (
              <VideoTag
                media_url={post.media_url}
                showAsAd={showAsAd}
                post_date={post.post_date}
                permalink={post.permalink}
                post_id={post.post_id}
                username={username}
                thumbnail={
                  post.thumbnail && post?.thumbnail?.split(",")[0]
                    ? post.thumbnail.split(",")[0]
                    : "/assets/dummy_video.png"
                }
                shop_link={post.shop_link}
                tagged_link={post.tagged_link}
                external_link={post.external_link}
                platform={platform}
                name={name}
              />
            ) : (
              // <ImagePostTag
              //   media_url={post.media_url}
              //   showAsAd={showAsAd}
              //   post_date={post.post_date}
              //   permalink={post.permalink}
              //   post_id={post.post_id}
              //   username={username}
              //   shop_link={post.shop_link}
              //   tagged_link={post.tagged_link}
              //   external_link={post.external_link}
              // />
              <div
                className=""
                style={{
                  alignSelf: "center",
                  backgroundColor: "black", // Light grey background
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "10px",
                  // height: "300px",
                  color: "#000",
                  flexDirection: "column", // Stack items vertically
                  textAlign: "center", // Center text inside the div
                }}
              >
                <span className="newsletter-label" style={{ display: "block" }}>
                  LinkedIn Post
                </span>
                <span className="date" style={{ display: "block" }}>
                  {formatPostDate(post.post_date)}
                </span>
              </div>
            )}
          </>
        )
      ) : (
        <>
          <div
            className="creator-feed-card-video-image"
            style={{
              alignSelf: "center",
              backgroundColor: "black", // Light grey background
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "10px",
              height: "300px",
              color: "#000",
              flexDirection: "column", // Stack items vertically
              textAlign: "center", // Center text inside the div
            }}
          >
            <span className="newsletter-label" style={{ display: "block" }}>
              LinkedIn Post
            </span>
            <span className="date" style={{ display: "block" }}>
              {formatPostDate(post.post_date)}
            </span>
          </div>
          <RefTag
            media_url={post.media_url}
            showAsAd={showAsAd}
            post_date={post.post_date}
            permalink={post.permalink}
            shop_link={post.shop_link}
            post_id={post.post_id}
            username={username}
            tagged_link={post.tagged_link}
            external_link={post.external_link}
            platform={platform}
            name={name}
          />
        </>
      )}

      {showCaption && (
        <>{post.caption ? <Caption caption={post.caption} /> : ""}</>
      )}

      {showComments && (
        <>{post.comments ? <Comments comments={post.comments} /> : ""}</>
      )}
    </div>
  );
}
